<template>
    <div class="hero-header" :style="styleProps">
        <h1 v-html="title" class="hero-header__title" />
        <AuthorCard v-if="articleAuthor" :author="articleAuthor"></AuthorCard>
        <div
            class="hero-header__image-container"
            :style="backgroundImageStyle"
        ></div>
    </div>
</template>

<script>
import AuthorCard from '@organisms/SEOArticlePartials/partials/AuthorsCard.vue';

export default {
    name: 'AdsenseHeader',
    components: { AuthorCard },
    props: {
        title: {
            type: String,
            default: '',
        },
        titleColor: {
            type: String,
            default: '',
        },
        backgroundImage: {
            type: String,
            default: '',
        },
        articleAuthor: {
            type: Object,
        },
    },
    computed: {
        styleProps() {
            return {
                '--titleColor': this.titleColor,
            };
        },
        backgroundImageStyle() {
            return {
                backgroundImage: `url(${this.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            };
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/mixins';
@import '@/sass/themes';
@import '@/sass/font-mixin';
.hero-header {
    display: flex;
    flex-direction: column;
    gap: 24px;

    &__title {
        font-size: 30px;
        font-weight: bold;
        line-height: 1.2;
        color: var(--titleColor);

        @include mq('tablet') {
            font-size: 48px;
        }
    }

    &__image-container {
        position: relative;
        padding-bottom: 37.5%;
        border-radius: 16px;
        overflow: hidden;
    }
}

::v-deep .author {
    margin: 0;
}

::v-deep .author .container .content .name {
    color: var(--primary, #e11d48);
}
</style>
